// File: src/assets/zonke-energy-tcs.js

const zonkeEnergyTCs = `
<div class="terms-container">
  <h1 class="terms-title">Zonke Energy Terms & Conditions</h1>
  
  <section class="terms-section">
    <h2 class="section-title">Who is Zonke Energy?</h2>
    <p class="section-text">
      Zonke Energy is an independent business with a mission to serve off-grid informal settlements with solar electricity on a pre-paid basis. Our service is designed to meet essential energy needs for households that are waiting for Eskom electrification. It is designed to run medium power loads like lights, phones, TVs and refrigerators, but is not a replacement for Eskom electrification – it cannot power kettles, stoves, or heaters. Our purpose is to demonstrate the potential for clean and affordable energy to change lives in informal settlements.
    </p>
    <p class="section-text">
      Zonke Energy operates independent solar generators. All electricity is generated by solar panels, and a battery is used to store power for nighttime. There is no connection with the grid, which means that if there is no sun for a long time power can switch off. It is therefore sometimes necessary to save electricity – this is different from a normal Eskom connection.
    </p>
    <p class="section-text">
      Zonke Energy is an independent business, with no connection to Eskom, the City of Cape Town, government or political entities.
    </p>
  </section>
  
  <section class="terms-section">
    <h2 class="section-title">Joining Fee</h2>
    <p class="section-text">
      Households wishing to receive a Zonke Energy connection must pay a non-refundable R550 joining fee (minus any applicable discounts). Upon proof of payment, Zonke Energy will then install a connection in the client's house, including outdoor cable, internal house wiring, switches, plug box, converter box, 3 indoor lights, and 1 outdoor security light.
    </p>
    <p class="section-text highlighted">
      The joining fee is non-refundable.
    </p>
  </section>
  
  <section class="terms-section">
    <h2 class="section-title">Energy Grant</h2>
    <p class="section-text">
      In some locations (currently only Qandu Qandu informal settlement) Zonke Energy, together with its partners, is piloting an energy grant that might in future be provided by the City of Cape Town or national government. This project's purpose is to gather real-world experience of such a policy to allow informed decision-making by policy makers.
    </p>
    <p class="section-text">
      All prices shown in this form are the full-cost price before the energy grant. For the term of this project (2 years from 1 Dec 2024), the grant will be R160 per client per month.
    </p>
    <p class="section-text">
      The project is not funded by the City of Cape Town or Eskom. Instead, funding comes from international organisations (Energy and Environment Partnership and Energy Catalyst) with an interest in promoting private businesses addressing the Just Energy Transition. The funding is provided to for-profit entities working to delivery low-carbon energy to off-grid households. Funding will cease after the project term (2 years).
    </p>
  </section>
  
  <section class="terms-section">
    <h2 class="section-title">Annual Contract</h2>
    <p class="section-text">
      Zonke Energy clients agree to a minimum 1-year contract period, making 12 payments on a monthly basis from the date of signing. After the initial 12-month period, clients may cancel their service with 1 month notice. Should 2 months elapse without payment, Zonke Energy will arrange with the client for the removal of its equipment from the dwelling. The client will not be eligible for future service offerings or re-connection. Also note the joining fee is non-refundable. In return, Zonke Energy agrees to provide an ongoing energy service to the client. All service issues will be resolved by Zonke Energy staff at no cost to the client (excluding cases of vandalism, tampering, or theft).
    </p>
  </section>
  
  <section class="terms-section">
    <h2 class="section-title">Payments</h2>
    <p class="section-text">
      Zonke Energy delivers its service on a monthly basis. Payments are due on or before the first day of the month. If payment is not received by 12pm, power to the client's premise will be switched off until made. As noted before ("Energy Grant") clients are eligible for a monthly R160 energy grant. However, if payment is not made by the first of the month, the grant will be reduced for that month proportional to the date the payment is made. For example, if payment is made on 5 May, the grant payable would be R135.
    </p>
  </section>
  
  <section class="terms-section">
    <h2 class="section-title">Daily Energy Limits</h2>
    <p class="section-text">
      Zonke Energy offers its service via tiers called "Packages" (Lights, Entertainment, and Refrigeration). Each tier entitles the client to a maximum energy quota per day. Should a client reach this quota, power to the premises will be switched off until the reset time (usually 17h00). Power is then restored and the daily quota is reset.
    </p>
  </section>
  
  <section class="terms-section">
    <h2 class="section-title">Moving & Inclement Weather</h2>
    <p class="section-text">
      Should a client move house, they must inform Zonke Energy of either a desire to end service or move their connection. Zonke Energy will do its best to relocate their connection to a new tower if possible. Costs may apply. From time to time Zonke Energy must switch off power due to inclement weather or maintenance issues. If for any reason power must be switched off after a client has paid, a credit will be applied to all affected clients in proportion to the lost time.
    </p>
  </section>
</div>
`;

export default zonkeEnergyTCs;
